import styled, { css } from 'styled-components';
import {
  ButtonAppearance,
  Button,
  Box,
  SideSheetClose,
  ButtonProps,
  ButtonSize,
  Avatar,
  SideSheetContentCol,
} from '@bechtel/gds';
import { FC } from 'react';
interface PickupTimeHeaderStyledProps {
  isRequestExpired: boolean;
}

export const SideSheetCloseStyled = styled(SideSheetClose).attrs({
  appearance: ButtonAppearance.SECONDARY,
  size: ButtonSize.SMALL,
})`
  ${({ theme }) =>
    css`
      border: none;
      margin-right: ${theme.spacings[500]};
      position: absolute;
      top: ${theme.spacings[500]};
      right: 0px;
    `}
`;
export const AvatarRegularStyled = styled(Avatar)`
  border-width: 1px !important;
  ${({ theme }) => css`
    border-color: ${theme.colors.white};
  `}
`;

export const DeleteButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.TERTIARY,
})`
  ${({ theme }) => css`
    width: auto;
    background-color: ${theme.colors.red[100]};
    color: ${theme.colors.grey[1000]};
    padding-top: ${theme.spacings[400]};
    padding-right: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[400]};
    margin-left: ${theme.spacings[450]};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    &:hover {
      background-color: ${theme.colors.red[100]};
    }
  `}
`;

export const PickupTimeHeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
})<PickupTimeHeaderStyledProps>`
  ${({ theme, isRequestExpired }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${isRequestExpired ? theme.colors.red[100] : theme.colors.grey[200]};
  `}
`;

export const SideSheetContentColStyled = styled(SideSheetContentCol)`
  border-right: 1px solid ${({ theme }) => theme.colors.grey[300]};
  flex-basis: 44%;
  overflow-y: hidden;
`;

export const EditWeldTabStyled = styled(Box).attrs({ pl: { sm: '400' } })`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  min-width: 110px;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const EditRodRequestDetailStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  overflow-y: auto;
  height: calc(100vh - 210px);
`;

export const AssociatedWeldStyled = styled(EditRodRequestDetailStyled)`
  height: calc(100vh - 255px);
`;

export const WeldSelectStyled = styled(Box).attrs({ px: { sm: '500' }, py: { sm: '450' } })`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;
